export const SexoArray =[
    {id:'H',display:'HOMBRE'},
    {id:'M',display:'MUJER'},
]